import { render, staticRenderFns } from "./AttentionSign.vue?vue&type=template&id=752fdfca&scoped=true"
import script from "./AttentionSign.vue?vue&type=script&lang=js"
export * from "./AttentionSign.vue?vue&type=script&lang=js"
import style0 from "./AttentionSign.vue?vue&type=style&index=0&id=752fdfca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752fdfca",
  null
  
)

export default component.exports